var _slicedToArray = require("/home/runner/work/kourikoulom/kourikoulom/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _toConsumableArray = require("/home/runner/work/kourikoulom/kourikoulom/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var fromEntries = require("lodash.frompairs");

var _important = function _important(target) {
  if (Array.isArray(target)) {
    return [].concat(_toConsumableArray(target), ["!important"]);
  }

  if (target === Object(target)) {
    return fromEntries(Object.entries(target).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      return [key, _important(value)];
    }));
  }

  return "".concat(target, " !important");
};

exports.important = _important;